import { TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';

export interface MenuModalDataInterface {
  menuContent: TemplateRef<any>;
  menuHeader?: TemplateRef<any>;
  menuFooter?: TemplateRef<any>;
  title?: string;
  closeAfterClick?: boolean;
  actions?: MenuModalActionInterface[];
  disableActions?: boolean;
}

export interface MenuModalActionInterface {
  title: string;
  type?: MenuModalButtonTypeEnum;
  closeModal?: boolean;
  focus?: boolean;
  action?: (value?: any) => Observable<any>;
}

export enum MenuModalButtonTypeEnum {
  PRIMARY,
  SECONDARY,
}
